import { connect } from 'react-redux'
import Auteur from './Auteur.jsx'
import { saveDates } from './actions/auteur.js'

const mapStateToProps = (state) => {
    return {
        'aid': state.aid,
        'date1' : state.date1,
        'date2' : state.date2,
        'auteur1' : state.auteur1,
        'auteur2' : state.auteur2,
        'processing' : state.processing,
        'error' : state.error,
        'loginok' : state.loginok,
        'route' : state.route
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        'saveDates' : (aid,d1,d2) => {
            return dispatch(saveDates(aid,d1,d2));
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Auteur);




// WEBPACK FOOTER //
// ./auteur/AuteurContainer.jsx